var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:_vm.computedClass},[_vm._t("default",null,{"context":_vm.model.$item})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }